<template>
    <div class="admin-instance-page">
        <div class="nk-block-head nk-block-head-sm">
            <div class="nk-block-between align-items-start">
                <div class="nk-block-head-content admin-instance-page__intro">
                    <router-link
                        to="/currency"
                        class="admin-instance-page__back admin-instance-page__back--pill"
                        :title="trans('currency.currency')"
                        :aria-label="trans('currency.currency')"
                    >
                        <admin-icon name="chevron-left" aria-hidden="true"></admin-icon>
                    </router-link>
                    <div class="admin-instance-page__intro-text">
                        <div class="admin-instance-list__title-row">
                            <h3 class="nk-block-title page-title mb-0">{{trans('currency.edit_currency')}}</h3>
                        </div>
                        <div class="nk-block-des text-soft">
                            <p>{{ trans('currency.module_info_description') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card admin-plan-form-card">
            <div class="card-body admin-plan-form-card__body">
                <currency-form :id="id"></currency-form>
            </div>
        </div>
    </div>
</template>

<script>
    import currencyForm from './form';

    export default {
        components : { currencyForm },
        data() {
            return {
                id:this.$route.params.id
            }
        },
        mounted(){
            if(!helper.hasPermission('edit-currency')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }
        }
    }
</script>
